import InputTypesEnum from '../../../Enums/InputTypesEnum';
import CheckService from '../../../Services/CheckService';
import PrintCheckItem from './PrintCheckItem';

// Task-style "Checks - Create Pdf" wizard. No entityName so the plain title wins.
// waitForServiceFunction returns false so the wizard fires the request without waiting
// (fire-and-forget) and shows messageOnSuccess immediately, matching the old panel's
// waitForResponseOnSubmit = false behavior (the pdf is delivered to the user's file repository).
export default class PrintCheckWindowDescription {
  static titleForCreate = 'Checks - Create Pdf';
  static titleForEdit = 'Checks - Create Pdf';
  static itemType = PrintCheckItem;
  static serviceFunction = CheckService.CheckGeneratePdf;
  static waitForServiceFunction = () => false;
  static messageOnSuccess =
    'The pdf creation process has been started. You will receive the file in your personal file repository.';
  static finishButtonLabel = 'Start';

  static pagesInGeneralEditWizzard = [
    {
      label: 'General',
      fields: [
        {
          fieldName: 'FirstCheck',
          label: 'Check Number',
          className: 'col-12',
          type: InputTypesEnum.Number,
        },
      ],
    },
  ];
}
